export default function isNationalityBlocked(blockedCountries: string[], _code: string): boolean {
  const blocked = blockedCountries.some((code) => code === _code)
  return blocked
}
